import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import Divider from '@duke-hq/filters/components/Divider';
import LocationFilterBase from '@duke-hq/filters/components/LocationFilterBase';
import type { LocationItem } from '@duke-hq/filters/types';

export default function LocationsFilter() {
  const { updateFilters, filters } = useFiltersContext();
  const { data } = trpcTenant.locations.listUserSiteAccess.useQuery({}, { initialData: [] });

  const locations: LocationItem[] = data.map((loc) => ({
    id: loc.id,
    name: loc.name,
    state: loc.state,
    type: loc.type === 'region' ? 'region' : 'site',
  }));
  const { sites = [], regions = [] } = filters;

  const selected = [...sites.map((id) => `site_${id}`), ...regions.map((id) => `region_${id}`)];

  const handleChange = (sites: string[], regions: string[]) => {
    updateFilters({ sites, regions });
  };

  if (locations.length <= 1) {
    return null;
  }

  return (
    <>
      <Divider />
      <LocationFilterBase
        locations={locations}
        onChange={handleChange}
        value={selected}
        variant="ghost"
      />
    </>
  );
}
